var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.33329H5V1.66663H3.33333V16.6666H2.5V18.3333H5.83333V16.6666H5V12.5H15.8333C16.0543 12.5 16.2663 12.4122 16.4226 12.2559C16.5789 12.0996 16.6667 11.8876 16.6667 11.6666V4.16663C16.6667 3.94561 16.5789 3.73365 16.4226 3.57737C16.2663 3.42109 16.0543 3.33329 15.8333 3.33329ZM15 10.8333H5V4.99996H15V10.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxFlag);
export default __webpack_public_path__ + "static/media/bx-flag.fbc4bd24e0fa106bab641c07b877d7e8.svg";
export { ForwardRef as ReactComponent };